"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roadmap = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var react_2 = __importDefault(require("react"));
var FieldFormatter_1 = require("../FieldFormatter");
var FlexView_1 = require("../FlexView");
var PanelInfo_1 = require("../PanelInfo");
var Spacer_1 = require("../Spacer");
var Step_1 = require("./Step");
require("./roadmap.css");
var Roadmap = /** @class */ (function (_super) {
    __extends(Roadmap, _super);
    function Roadmap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Roadmap.prototype.render = function () {
        var _this = this;
        var activeStep = this.props.steps.reduce(function (carry, currentStep, currentIndex) { return (currentStep.done ? currentIndex : carry); }, 0);
        var activePointerPosition = function () {
            var offset = ((activeStep + 0.5) * 95) / _this.props.steps.length;
            return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                @media (min-width: ", ") {\n                    left: ", "%;\n                }\n                @media (max-width: ", ") {\n                    top: ", "%;\n                }\n            "], ["\n                @media (min-width: ", ") {\n                    left: ", "%;\n                }\n                @media (max-width: ", ") {\n                    top: ", "%;\n                }\n            "])), Roadmap.BREAKPOINT, offset, Roadmap.BREAKPOINT, offset);
        };
        var renderDetailMessage = function (title, caption) { return ((0, jsx_runtime_1.jsx)(PanelInfo_1.PanelInfo.Detail, __assign({ title: title }, { children: caption }))); };
        var renderDetailsAction = function (details) { return ((0, jsx_runtime_1.jsxs)(react_2.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Clickabile, __assign({ onClick: details.action }, { children: details.label })), (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { width: 1 })] })); };
        var renderAction = function (details) { return ((0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ vAlignContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, lg: 6 }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ hAlignContent: "left" }, { children: renderDetailMessage(details.title, details.caption) })) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, hides: ['lg', 'xl'] }, { children: (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { height: 2.5 }) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ lg: 1, hides: ['xs', 'sm', 'hs', 'hm', 'md'] }, { children: (0, jsx_runtime_1.jsx)(Spacer_1.Spacer, { width: 1 }) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, lg: 5, hides: ['xs', 'sm', 'hs', 'hm', 'md'] }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ className: "action-label", hAlignContent: "right" }, { children: renderDetailsAction(details) })) })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 12, lg: 5, hides: ['lg', 'xl'] }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ className: "action-label", hAlignContent: "left" }, { children: renderDetailsAction(details) })) }))] }))); };
        var renderRoadmapDetail = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.details), (0, Option_1.map)(function (details) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "roadmap-detail" }, { children: (0, jsx_runtime_1.jsx)(PanelInfo_1.PanelInfo, __assign({ theme: "white-highlight", style: {
                        margin: '0',
                        padding: '1.5rem',
                        height: '100%',
                    } }, { children: details.type === 'info'
                        ? renderDetailMessage(details.title, details.caption)
                        : renderAction(details) })) }))); }), O.toNullable);
        };
        var renderPointer = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.details), (0, Option_1.map)(function (_) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "roadmap-head-pointer-box" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)('roadmap-head-pointer-border'), css: activePointerPosition() }), (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)('roadmap-head-pointer-fill'), css: activePointerPosition() })] }))); }), O.toNullable);
        };
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "roadmap" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "roadmap-head" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "roadmap-head-step-box" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "roadmap-head-steps" }, { children: this.props.steps.map(function (step, index) { return ((0, jsx_runtime_1.jsx)(Step_1.Step, { label: step.label, enabled: step.done || index < activeStep, active: activeStep === index, isFirst: index === 0 }, index)); }) })), renderPointer()] })) })), renderRoadmapDetail()] })));
    };
    Roadmap.SMILEY_TODO_COLOR = '#FED9BF';
    Roadmap.SMILEY_DONE_COLOR = '#FFB03A';
    Roadmap.BREAKPOINT = '768px';
    return Roadmap;
}(react_2.default.PureComponent));
exports.Roadmap = Roadmap;
var templateObject_1;
//# sourceMappingURL=Roadmap.js.map